import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Swal from "sweetalert2";
import { currentDateAndTime, decodeData } from '../../Constants/constants';


// Sample blood group options
const bankAccountType = [
  { value: "Current Account", label: "Current Account" },
  { value: "Saving Account", label: "Saving Account" },
  { value: "Fixed Deposit Account", label: "Fixed Deposit Account" },
  { value: "Recurring Deposit Account", label: "Recurring Deposit Account" },
  { value: "NRI Account", label: "NRI Account" },
  // Add more options as needed
];
const salaryTransferMode = [
  { value: 'Cheques', label: 'Cheques' },
  { value: 'Demand Draft (DD)', label: 'Demand Draft (DD)' },
  { value: 'Cash payments', label: 'Cash payments' },
  { value: 'Digital wallets', label: 'Digital wallets' },
  { value: 'Unified Payments Interface (UPI)', label: 'Unified Payments Interface (UPI)' },
  // Add more options as needed
];

class BankDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_bank_id: 0,
      name_As_Per_Bank_Record: '',
      enter_Bank_Name: '',
      account_Number: '',
      branch_Name: '',
      IFSC_code: '',
      account_Type: '',
      salary_Mode_Of_Trasfer: '',
      errors: {}, // Store validation errors
      loadingSubmit:false,
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetInfo();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }


  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    this.setState({loadingSubmit:true});
    var formData = {
      employee_id: employee_id,
      employee_name_as_per_bank: this.state.name_As_Per_Bank_Record,
      employee_bank_name: this.state.enter_Bank_Name,
      employee_bank_account_number: this.state.account_Number,
      employee_bank_branch_name: this.state.branch_Name,
      employee_bank_Ifsc: this.state.IFSC_code,
      employee_bank_account_type: this.state.account_Type,
      employee_bank_mode_of_transfer: this.state.salary_Mode_Of_Trasfer,
      date: currentDateAndTime(),
    }
    if (this.state.employee_bank_id !== 0) {
      formData.employee_bank_id = this.state.employee_bank_id;
    }

    axios.post(`${apiURL}Employees/CreateBank`, formData, { headers })
    .then((response) => {

      const { success } = response.data;
      if (success === true) {
        this.setState({
          employee_bank_id: 0,
          name_As_Per_Bank_Record: '',
          enter_Bank_Name: '',
          account_Number: '',
          branch_Name: '',
          IFSC_code: '',
          account_Type: '',
          salary_Mode_Of_Trasfer: '',
          loadingSubmit:false,
          loadingList: true,
        }, (prevState) => {
          this.GetInfo();
        })

        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
        this.setState({ loadingList: true ,loadingSubmit:false }, (prevState) => {
          this.GetInfo();
        })
      }

    }).catch((error)=>{
      console.log("Employees/CreateBank ERROR:",error);
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: "Opps...! Something went wrong!",
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick:false
      })
    })
  };

  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetBankInfo?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true && data.length !== 0) {
        this.setState(
          {
            employee_bank_id: data[0].employee_bank_id || 0,
            name_As_Per_Bank_Record: data[0].employee_name_as_per_bank,
            enter_Bank_Name: data[0].employee_bank_name,
            account_Number: data[0].employee_bank_account_number,
            branch_Name: data[0].employee_bank_branch_name,
            IFSC_code: data[0].employee_bank_Ifsc,
            account_Type: data[0].employee_bank_account_type,
            salary_Mode_Of_Trasfer: data[0].employee_bank_mode_of_transfer,
          }
        )
      }
    });
  }
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetInfo();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };



  // Custom validation function with regex
  validateForm = () => {
    const errors = {};
    const ifscCodeRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
    if (!this.state.name_As_Per_Bank_Record) errors.name_As_Per_Bank_Record = 'Name As Per Bank Record is required';
    if (!this.state.enter_Bank_Name) errors.enter_Bank_Name = 'Bank Name is required';
    if (!this.state.account_Number) errors.account_Number = 'Account Number is required';
    if (!this.state.branch_Name) errors.branch_Name = 'Branch Name is required';
    // if (!this.state.account_Type) errors.account_Type = 'Account Type is required';
    // if (!this.state.salary_Mode_Of_Trasfer) errors.salary_Mode_Of_Trasfer = 'Salary Mode Of Transfer is required';

    if (!this.state.IFSC_code) {
      errors.IFSC_code = 'IFSC code is required';
    } else if (!ifscCodeRegex.test(this.state.IFSC_code)) {
      errors.IFSC_code = 'Invalid IFSC code. Must be a valid IFSC code.';
    }
    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <h5>
          Bank Details
          <span
            style={{
              color: "blue",
              marginLeft: "5px",
              borderRadius: "50%",
              background: "#f0f8ff",
              padding: "2px 6px",
              display: "inline-block",
              textAlign: "center",
              width: "20px",
              height: "20px",
              lineHeight: "20px",
            }}
          >
            *
          </span>
        </h5>
        <p className="text-muted">
          Fill all information below
        </p>


        <div className="container mt-2">
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="name_As_Per_Bank_Record" className="form-label">Name As Per Bank Record:</label>
                <input
                  type="text"
                  id="name_As_Per_Bank_Record"
                  name="name_As_Per_Bank_Record"
                  value={this.state.name_As_Per_Bank_Record}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.name_As_Per_Bank_Record ? 'is-invalid' : ''}`}
                  placeholder="Enter Your Name"
                  required
                />
                {errors.name_As_Per_Bank_Record && <div className="invalid-feedback">{errors.name_As_Per_Bank_Record}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="enter_Bank_Name" className="form-label">  Bank Name:</label>
                <input
                  type="text"
                  id="enter_Bank_Name"
                  name="enter_Bank_Name"
                  value={this.state.enter_Bank_Name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.enter_Bank_Name ? 'is-invalid' : ''}`}
                  placeholder="Enter Bank Name"
                  required
                />
                {errors.enter_Bank_Name && <div className="invalid-feedback">{errors.enter_Bank_Name}</div>}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="account_Number" className="form-label">Account Number:</label>
                <input
                  type="text"
                  id="account_Number"
                  name="account_Number"
                  value={this.state.account_Number}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.account_Number ? 'is-invalid' : ''}`}
                  placeholder="Enter Account Number"
                  required
                />
                {errors.account_Number && <div className="invalid-feedback">{errors.account_Number}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="branch_Name" className="form-label">Branch Name:</label>
                <input
                  type="text"
                  id="branch_Name"
                  name="branch_Name"
                  value={this.state.branch_Name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.branch_Name ? 'is-invalid' : ''}`}
                  placeholder="Enter Branch Name"
                  required
                />
                {errors.branch_Name && <div className="invalid-feedback">{errors.branch_Name}</div>}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="IFSC_code" className="form-label">IFSC code:</label>
                <input
                  type="text"
                  id="IFSC_code"
                  name="IFSC_code"
                  value={this.state.IFSC_code}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.IFSC_code ? 'is-invalid' : ''}`}
                  placeholder="Enter IFSC code"
                  required
                />
                {errors.IFSC_code && <div className="invalid-feedback">{errors.IFSC_code}</div>}
              </div>


              {/* <div className="col-md-6 mb-3">
                <label htmlFor="account_Type" className="form-label">Account Type:</label>
                <Select
                  id="account_Type"
                  name="account_Type"
                  value={bankAccountType.find(option => option.value === this.state.account_Type)}
                  onChange={(selectedOption) => this.handleSelectChange('account_Type', selectedOption)}
                  options={bankAccountType}
                  placeholder="Select Account Type"
                  required
                />
                {errors.account_Type && <div className="text-danger">{errors.account_Type}</div>}
              </div> */}

            </div>
            {/* <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="salary_Mode_Of_Trasfer" className="form-label">Salary Mode Of Trasfer:</label>
                <Select
                  id="salary_Mode_Of_Trasfer"
                  name="salary_Mode_Of_Trasfer"
                  value={salaryTransferMode.find(option => option.value === this.state.salary_Mode_Of_Trasfer)}
                  onChange={(selectedOption) => this.handleSelectChange('salary_Mode_Of_Trasfer', selectedOption)}
                  options={salaryTransferMode}
                  placeholder="Select Salary Mode"
                  required
                />
                {errors.salary_Mode_Of_Trasfer && <div className="text-danger">{errors.salary_Mode_Of_Trasfer}</div>}
              </div>
            </div> */}
          </form>
          <div className="d-flex justify-content-end" style={{ marginTop: "50px" }}>
            {!this.state.loadingSubmit?
            <button type="button" onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
            <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save
          </button>:
          <button className="btn btn-success btn-load">
            <span className="d-flex align-items-center">
                <span className="spinner-border flex-shrink-0" role="status">
                    <span className="visually-hidden">Loading...</span>
                </span>
                <span className="flex-grow-1 ms-2">
                    Saving...
                </span>
            </span>
          </button>
            }
            
           
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BankDetails);
